import moment from 'moment';

import ErrorUtil from '../util/ErrorUtil';
import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class SessaoService extends Service {
    apregoar(numeroProcesso, idSessao) {
        this.getSessaoApi()
            .apregoar(numeroProcesso, idSessao)
            // eslint-disable-next-line unicorn/prefer-await
            .then(() => this.notificarPregao(idSessao, numeroProcesso));
    }

    // eslint-disable-next-line unicorn/consistent-boolean-name
    apregoarPlanilha(idSessao, relator, marcarAusenciasAdvogados = false, totalDeProcessos) {
        this.getSessaoApi()
            .apregoarPlanilha(idSessao, relator, marcarAusenciasAdvogados, totalDeProcessos)
            // eslint-disable-next-line unicorn/prefer-await
            .then(() =>
                this.notificarPregao(
                    idSessao,
                    `${relator.sigla}-${relator.cpf}`,
                    marcarAusenciasAdvogados,
                    totalDeProcessos
                )
            );
    }

    cancelarPregao(numeroProcesso, idSessao) {
        this.getSessaoApi()
            .cancelarPregao(numeroProcesso, idSessao)
            // eslint-disable-next-line unicorn/prefer-await
            .then(() => this.notificar(idSessao));
    }

    cancelarPregaoLote(idSessao, siglaRelator) {
        this.getSessaoApi()
            .cancelarPregaoLote(idSessao, siglaRelator)
            // eslint-disable-next-line unicorn/prefer-await
            .then(() => this.notificar(idSessao));
    }

    notificar(idSessao) {
        this.getSessaoApi().notificar(idSessao);
    }

    // eslint-disable-next-line unicorn/consistent-boolean-name
    notificarPregao(idSessao, numeroProcesso, marcarAusenciasAdvogados = false, totalDeProcessos) {
        this.getSessaoApi().notificarPregao(idSessao, numeroProcesso, marcarAusenciasAdvogados, totalDeProcessos);
    }

    async verificarLocalizacaoMagistrado(idSessao, sigla, cpf, converterSigla) {
        const resultado = await this.getSessaoApi().verificarLocalizacaoMagistrado(
            idSessao,
            sigla,
            cpf,
            converterSigla
        );
        return resultado;
    }

    testarAlteracaoMinuta(idSessao, numeroProcesso) {
        this.getSessaoApi().testarAlteracaoMinuta(idSessao, numeroProcesso);
    }

    notificarJulgamento(idSessao, numeroProcesso, clienteEnvelopeId) {
        this.getSessaoApi().notificarJulgamento(idSessao, numeroProcesso, clienteEnvelopeId);
    }

    notificarJulgamentoLote(idSessao, clienteEnvelopeId) {
        this.getSessaoApi().notificarJulgamentoLote(idSessao, clienteEnvelopeId);
    }

    notificarCronometroStart(idSessao, segTotal) {
        this.getSessaoApi().notificarCronometro(idSessao, 'INICIAR', segTotal);
    }

    notificarCronometroPause(idSessao, segTotal) {
        this.getSessaoApi().notificarCronometro(idSessao, 'PAUSAR', segTotal);
    }

    notificarCronometroParar(idSessao) {
        this.getSessaoApi().notificarCronometro(idSessao, 'PARAR');
    }

    async recuperarProcessoApregoado(localizacao) {
        const resultado = await this.getSessaoApi().recuperarProcessoApregoado(localizacao);
        return resultado;
    }

    async recuperarProcessoApregoadoAS(localizacao) {
        const resultado = await this.getSessaoApi().recuperarProcessoApregoadoAS(localizacao);
        return resultado;
    }

    async recuperarComposicaoPadraoOJC(siglaOrgaoJulgador) {
        const resultado = await this.getSessaoApi().recuperarComposicaoPadraoOJC(siglaOrgaoJulgador);
        return resultado;
    }

    async gravarComposicaoPadraoSessao(idSessao, composicao) {
        const resultado = await this.getSessaoApi().gravarComposicaoPadraoSessao(idSessao, composicao);
        return resultado;
    }

    async recuperarSessoesJulgamento(siglaOrgaoJulgador) {
        const sessoes = await this.getSessaoApi().recuperarSessoesJulgamento(siglaOrgaoJulgador);

        if (sessoes) {
            this.configurarProximaSessao(sessoes);
        }
        return sessoes;
    }

    async recuperarSessoesJulgamentoAS(siglaOrgaoJulgador) {
        const sessoes = await this.getSessaoApi().recuperarSessoesJulgamentoAS(siglaOrgaoJulgador);

        if (sessoes) {
            this.configurarProximaSessao(sessoes);
        }
        return sessoes;
    }

    // eslint-disable-next-line unicorn/consistent-boolean-name
    async recuperarSessaoJulgamento(idSessaoJulgamento, notificarOrdenacao, ignorarCacheServidor = false) {
        const sessao = await this.getSessaoApi().recuperarSessaoJulgamento(
            idSessaoJulgamento,
            notificarOrdenacao,
            ignorarCacheServidor
        );

        if (sessao && sessao.processos === undefined) {
            sessao.processos = [];
        }
        return sessao;
    }

    async recuperarProcessoSessao(idSessao, numeroProcesso, ignorarCacheServidor) {
        const resultado = await this.getSessaoApi().recuperarProcessoSessao(
            idSessao,
            numeroProcesso,
            ignorarCacheServidor
        );
        return resultado;
    }

    async recuperarSessaoComProcesso(idSessao, numeroProcesso) {
        const resultado = await this.getSessaoApi().recuperarSessaoComProcesso(idSessao, numeroProcesso);
        return resultado;
    }

    async recuperarComposicaoProcessoSessao(idSessao, numeroProcesso) {
        const resultado = await this.getSessaoApi().recuperarComposicaoProcessoSessao(idSessao, numeroProcesso);
        return resultado;
    }

    async consultarVersoesMinutaVoto(idSessao, numeroProcesso, isRelator = true) {
        const resultado = await this.getSessaoApi().consultarVersoesMinutaVoto(idSessao, numeroProcesso, isRelator);
        return resultado;
    }

    // eslint-disable-next-line unicorn/consistent-boolean-name
    async consultarVersaoMinutaVoto(idSessao, numeroProcesso, idGed, extensaoVersaoGed, naoRelator = false) {
        const resultado = await this.getSessaoApi().consultarVersaoMinutaVoto(
            idSessao,
            numeroProcesso,
            idGed,
            extensaoVersaoGed,
            naoRelator
        );
        return resultado;
    }

    configurarProximaSessao(sessoes) {
        // Inverte o array para buscar a última sessão cuja data seja maior ou igual à atual para defini-la como próxima sessão
        const proximasSessoes = this.getProximasSessoes(sessoes).toReversed();
        let isProximaEncontrada = false;

        if (proximasSessoes.length > 0) {
            // eslint-disable-next-line unicorn/no-for-each
            proximasSessoes.forEach((proximaSessao) => {
                if (
                    moment(proximaSessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss')
                        .startOf('day')
                        .isSame(moment().startOf('day'), 'day')
                ) {
                    proximaSessao.hoje = true;
                } else if (!isProximaEncontrada) {
                    proximaSessao.proxima = true;
                    isProximaEncontrada = true;
                }
            });
        }
    }

    getProximasSessoes(sessoes) {
        const retorno = sessoes.filter((sessao) => {
            return moment(sessao.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss')
                .startOf('day')
                .isSameOrAfter(moment().startOf('day'), 'day');
        });
        return retorno;
    }

    salvarOrdenacaoSecretario(idSessao, numeroProcesso, ordenacaoSecretario, clienteEnvelopeId) {
        let promise;

        // eslint-disable-next-line unicorn/prefer-ternary
        if (ordenacaoSecretario && ordenacaoSecretario.length > 0) {
            promise = this.getSessaoApi().salvarOrdenacaoSecretario(
                idSessao,
                numeroProcesso,
                ordenacaoSecretario,
                clienteEnvelopeId
            );
        } else {
            promise = this.getSessaoApi().excluirOrdenacaoSecretario(idSessao, numeroProcesso, clienteEnvelopeId);
        }
        return promise;
    }

    salvarSequenciaPreferenciaArbitraria(idSessao, numeroProcesso, sequenciaPreferencia) {
        return this.getSessaoApi().salvarSequenciaPreferenciaArbitraria(idSessao, numeroProcesso, sequenciaPreferencia);
    }

    salvarSequenciaPreferenciaInscricao(idSessao, numeroProcesso, oab, sequenciaPreferencia) {
        if (sequenciaPreferencia && sequenciaPreferencia.length > 0) {
            this.getSessaoApi().salvarSequenciaPreferenciaInscricao(
                idSessao,
                numeroProcesso,
                oab,
                sequenciaPreferencia
            );
        } else {
            this.getSessaoApi().excluirSequenciaPreferenciaInscricao(idSessao, numeroProcesso, oab);
        }
    }

    recuperarDestaques(idSessao, numeroProcesso, siglaMagistrado) {
        return this.getSessaoApi().recuperarDestaques(idSessao, numeroProcesso, siglaMagistrado);
    }

    recuperarVotosVista(idSessao, numeroProcesso, siglaMagistrado) {
        return this.getSessaoApi().recuperarVotosVista(idSessao, numeroProcesso, siglaMagistrado);
    }

    recuperarConteudoDestaque(idSessao, numeroProcesso, siglaMagistrado, idDestaque) {
        return this.getSessaoApi().recuperarConteudoDestaque(idSessao, numeroProcesso, siglaMagistrado, idDestaque);
    }

    recuperarConteudoRtfDestaque(idSessao, numeroProcesso, siglaMagistrado, idDestaque) {
        return this.getSessaoApi().recuperarConteudoRtfDestaque(idSessao, numeroProcesso, siglaMagistrado, idDestaque);
    }

    registrarVistaMesa(idSessao, numeroProcesso, magistrados, clienteEnvelopeId) {
        try {
            return this.getSessaoApi().registrarVistaMesa(idSessao, numeroProcesso, magistrados, clienteEnvelopeId);
        } catch (error) {
            return error.message;
        }
    }

    async excluirVistaMesa(idSessao, numeroProcesso, magistrados) {
        try {
            const resultado = await this.getSessaoApi().excluirVistaMesa(idSessao, numeroProcesso, magistrados);
            return resultado;
        } catch (error) {
            return error.message;
        }
    }

    registrarRetornoVistaRegimental(idSessao, numeroProcesso, magistrados, clienteEnvelopeId) {
        try {
            return this.getSessaoApi().registrarRetornoVistaRegimental(
                idSessao,
                numeroProcesso,
                magistrados,
                clienteEnvelopeId
            );
        } catch (error) {
            return error.message;
        }
    }

    alterarRetornoVistaRegimental(idSessao, numeroProcesso, magistrados, clienteEnvelopeId) {
        try {
            return this.getSessaoApi().alterarRetornoVistaRegimental(
                idSessao,
                numeroProcesso,
                magistrados,
                clienteEnvelopeId
            );
        } catch (error) {
            return error.message;
        }
    }

    async excluirRetornoVistaRegimental(idSessao, numeroProcesso, magistrados) {
        try {
            const resultado = await this.getSessaoApi().excluirRetornoVistaRegimental(
                idSessao,
                numeroProcesso,
                magistrados
            );
            return resultado;
        } catch (error) {
            return error.message;
        }
    }

    async alterarProcurador(idSessao, numeroProcesso, procurador) {
        const resultado = await this.getSessaoApi().alterarProcurador(idSessao, numeroProcesso, procurador);
        return resultado;
    }

    async alterarSituacaoSessao(idSessao, situacao) {
        const resultado = await this.getSessaoApi().alterarSituacaoSessao(idSessao, situacao);
        return resultado;
    }

    async recuperarProcurador(idSessao) {
        const resultado = await this.getSessaoApi().recuperarProcurador(idSessao);
        return resultado;
    }

    async gravarProcurador(idSessao, procurador) {
        await this.getSessaoApi().gravarProcurador(idSessao, procurador);
    }

    async gravarPresidente(idSessao, presidente) {
        await this.getSessaoApi().gravarPresidente(idSessao, presidente);
    }

    // eslint-disable-next-line unicorn/consistent-boolean-name
    async ordenarProcessos(idSessao, aguardarResposta = false) {
        if (aguardarResposta) {
            await this.getSessaoApi().ordenarProcessos(idSessao);
        }

        const resultado = await this.getSessaoApi().ordenarProcessos(idSessao);
        return resultado;
    }

    async incluirProcesso(idSessao, numeroProcesso, preparacaoPauta, tipoJulgamento) {
        const resultado = await this.getSessaoApi().incluirProcesso(
            idSessao,
            numeroProcesso,
            preparacaoPauta,
            tipoJulgamento
        );
        return resultado;
    }

    async listarPendencias(idSessao) {
        const resultado = await this.getSessaoApi().listarPendencias(idSessao);
        return resultado;
    }

    async recuperarTiposPendenciasFechamento() {
        const resultado = await this.getSessaoApi().recuperarTiposPendenciasFechamento();
        return resultado;
    }

    async listarSessoesPendentes(idsSessoes) {
        const idsString = idsSessoes.join(',');
        const resultado = await this.getSessaoApi().listarSessoesPendentes(idsString);
        return resultado;
    }

    async liberarVotosSessao(idSessao) {
        const resultado = await this.getSessaoApi().liberarVotosSessao(idSessao);
        return resultado;
    }

    async liberarDispositivosVoto(idSessao, numerosProcessos) {
        const resultado = await this.getSessaoApi().liberarDispositivosVoto(idSessao, numerosProcessos);
        return resultado;
    }

    async forcarAtualizacaoEmentaDecisao(idSessao, numeroProcesso) {
        const resultado = await this.getSessaoApi().forcarAtualizacaoEmentaDecisao(idSessao, numeroProcesso);
        return resultado;
    }

    async excluirProcurador(idSessao) {
        const resultado = await this.getSessaoApi().excluirProcurador(idSessao);
        return resultado;
    }

    async recuperarPautaJulgamento(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarPautaJulgamento(sessaoId);
        return resultado;
    }

    async excluirPautasJulgamento(sessaoId) {
        const resultado = await this.getSessaoApi().excluirPautasJulgamento(sessaoId);
        return resultado;
    }

    async recuperarPautaveis(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarPautaveis(sessaoId);
        return resultado;
    }

    async recuperarPartesPautaveis(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarPartesPautaveis(sessaoId);
        return resultado;
    }

    async recuperarJulgamentoAnteriorPautaveis(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarJulgamentoAnteriorPautaveis(sessaoId);
        return resultado;
    }

    async recuperarJulgamentosAnterioresSessao(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarJulgamentosAnterioresSessao(sessaoId);
        return resultado;
    }

    async recuperarUltimosAndamentosSessao(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarUltimosAndamentosSessao(sessaoId);
        return resultado;
    }

    async recuperarUltimosAndamentosPautaveis(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarUltimosAndamentosPautaveis(sessaoId);
        return resultado;
    }

    async recuperarPartesSessao(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarPartesSessao(sessaoId);
        return resultado;
    }

    async recuperarMovimentosDecisoesSessao(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarMovimentosDecisoesSessao(sessaoId);
        return resultado;
    }

    async recuperarDatasVotacaoVirtual(dataInicioSessaoPresencial, regrasResolucao591Cnj) {
        const resultado = await this.getSessaoApi().recuperarDatasVotacaoVirtual(
            dataInicioSessaoPresencial,
            regrasResolucao591Cnj
        );
        return resultado;
    }

    async recuperarDatasVotacaoPelaDataInicio(dataInicioVotacaoVirtual, regrasResolucao591Cnj) {
        const resultado = await this.getSessaoApi().recuperarDatasVotacao(
            dataInicioVotacaoVirtual,
            null,
            regrasResolucao591Cnj
        );
        return resultado;
    }

    async recuperarDatasVotacaoPelaDataFim(dataFimVotacaoVirtual, regrasResolucao591Cnj) {
        const resultado = await this.getSessaoApi().recuperarDatasVotacao(
            null,
            dataFimVotacaoVirtual,
            regrasResolucao591Cnj
        );
        return resultado;
    }

    async gravarPautaJulgamento(pautaJulgamento) {
        const resultado = await this.getSessaoApi().gravarPautaJulgamento(pautaJulgamento);
        return resultado;
    }

    async gerarAta(idSessao, tipoJulgamento) {
        const resultado = await this.getSessaoApi().gerarAta(idSessao, tipoJulgamento);
        return resultado;
    }

    async buscarOrgaosJulgadoresColegiados() {
        const resultado = await this.getSessaoApi().buscarOrgaosJulgadoresColegiados();
        return resultado;
    }

    async buscarOrgaosJulgadoresColegiadosAS() {
        const resultado = await this.getSessaoApi().buscarOrgaosJulgadoresColegiadosAS();
        return resultado;
    }

    async buscarMotivosImpedimentos(idSessao, numeroProcesso) {
        const resultado = await this.getSessaoApi().buscarMotivosImpedimentos(idSessao, numeroProcesso);
        return resultado;
    }

    async registrarAnaliseMinuta(idSessao, numeroProcesso) {
        const resultado = await this.getSessaoApi().registrarAnaliseMinuta(idSessao, numeroProcesso);
        return resultado;
    }

    async gerarPreVisualizacaoCertidao(idSessao, numeroProcesso, datasPreVisualizacaoCertidao) {
        const resultado = await this.getSessaoApi().gerarPreVisualizacaoCertidao(
            idSessao,
            numeroProcesso,
            datasPreVisualizacaoCertidao
        );
        return resultado;
    }

    async recuperarPrazosPublicacaoPauta(dataInicioJulgamento, dataDisponibilizacao) {
        const resultado = await this.getSessaoApi().recuperarPrazosPublicacaoPauta(
            dataInicioJulgamento,
            dataDisponibilizacao
        );
        return resultado;
    }

    async validarMotivosProcessoInapto(idSessao, numerosProcessos) {
        const resultado = await this.getSessaoApi().validarMotivosProcessoInapto(idSessao, numerosProcessos);
        return resultado;
    }

    async importarSalaSessao(registro) {
        const resultado = await this.processarOperacaoLote(
            () => this.getSessaoApi().importarSalaSessao(registro.sessaoId, registro.processo.numeroCompleto),
            registro
        );
        return resultado;
    }

    async reiniciarAnaliseDecisao(registro) {
        const resultado = await this.processarOperacaoLote(
            () => this.getSessaoApi().reiniciarAnaliseDecisao(registro.sessaoId, registro.processo.numeroCompleto),
            registro
        );
        return resultado;
    }

    async buscarDecisaoCertidaoAssinados(sessaoId) {
        return await this.getSessaoApi().buscarDecisaoCertidaoAssinados(sessaoId);
    }

    async buscarDadosAnaliseSecretaria(sessaoId) {
        return await this.getSessaoApi().buscarDadosAnaliseSecretaria(sessaoId);
    }

    async confirmarPublicarPauta(idSessao, publicarPautaDto, enviarCertidao, publicarDiario, tramitarInclusaoPauta) {
        let errosAcumulados = [];
        let publicarPautaDtoSucesso = { ...publicarPautaDto };

        if (enviarCertidao && this.temProcessos(publicarPautaDtoSucesso)) {
            const erros = await this.gerarCertidaoInclusaoPauta(idSessao, publicarPautaDtoSucesso);
            errosAcumulados = [...errosAcumulados, ...erros];
            publicarPautaDtoSucesso = this.removerFalhasPublicacao(errosAcumulados, publicarPautaDtoSucesso);
        }
        if (publicarDiario && this.temProcessos(publicarPautaDtoSucesso)) {
            const erros = await this.publicarPautaDiario(idSessao, publicarPautaDtoSucesso);
            errosAcumulados = [...errosAcumulados, ...erros];
            publicarPautaDtoSucesso = this.removerFalhasPublicacao(errosAcumulados, publicarPautaDtoSucesso);
        }
        if (tramitarInclusaoPauta && this.temProcessos(publicarPautaDtoSucesso)) {
            const erros = await this.tramitarInclusaoPauta(idSessao, publicarPautaDtoSucesso);
            errosAcumulados = [...errosAcumulados, ...erros];
            publicarPautaDtoSucesso = this.removerFalhasPublicacao(errosAcumulados, publicarPautaDtoSucesso);
        }
        return this.gerarResultadoOperacao(publicarPautaDtoSucesso.processosConfirmacao, errosAcumulados);
    }

    gerarResultadoOperacao(processosSucesso, erros) {
        const sucessos = processosSucesso.map((processo) => {
            return {
                numeroProcesso: processo.numero,
                erro: false
            };
        });
        const retorno = [...erros, ...sucessos];
        return retorno;
    }

    temProcessos(publicarPautaDto) {
        return publicarPautaDto.processosConfirmacao && publicarPautaDto.processosConfirmacao.length > 0;
    }

    removerFalhasPublicacao(erros, publicarPautaDto) {
        const processosConfirmacaoSucesso = publicarPautaDto.processosConfirmacao.filter((dto) =>
            erros.every((erro) => dto.numero !== erro.numeroProcesso)
        );
        publicarPautaDto.processosConfirmacao = processosConfirmacaoSucesso;
        return publicarPautaDto;
    }

    async cancelarDisponibilizacaoDiario(idSessao, numeroProcesso, motivoCancelamento) {
        const resultado = await this.getSessaoApi().cancelarDisponibilizacaoDiario(
            idSessao,
            numeroProcesso,
            motivoCancelamento
        );
        return resultado;
    }

    async cancelarDisponibilizacoesDiario(idSessao, numerosProcessos, motivoCancelamento) {
        const resultado = await this.tratarTarefaLote(
            () => this.getSessaoApi().cancelarDisponibilizacoesDiario(idSessao, numerosProcessos, motivoCancelamento),
            numerosProcessos,
            'Cancelar disponibilização em diário.'
        );
        return resultado;
    }

    async gerarCertidaoInclusaoPauta(idSessao, publicarPautaDto) {
        const resultado = await this.tratarTarefaLote(
            () => this.getSessaoApi().gerarCertidaoInclusaoPauta(idSessao, publicarPautaDto),
            publicarPautaDto.processosConfirmacao.map((processo) => processo.numero),
            'Gerar certidão de inclusão em pauta.'
        );
        return resultado;
    }

    async publicarPautaDiario(idSessao, publicarPautaDto) {
        const resultado = await this.tratarTarefaLote(
            () => this.getSessaoApi().publicarPautaDiario(idSessao, publicarPautaDto),
            publicarPautaDto.processosConfirmacao.map((processo) => processo.numero),
            'Publicar pauta no Diário.'
        );
        return resultado;
    }

    async tramitarInclusaoPauta(idSessao, publicarPautaDto) {
        const resultado = await this.tratarTarefaLote(
            () => this.getSessaoApi().tramitarInclusaoPauta(idSessao, publicarPautaDto),
            publicarPautaDto.processosConfirmacao.map((processo) => processo.numero),
            'Tramitar inclusão de processos em pauta.'
        );
        return resultado;
    }

    async tratarTarefaLote(operacao, numeros, mensagem) {
        let erros;

        try {
            const response = await operacao();
            erros = this.tratarRespostaTarefaLote(response.data);
        } catch (error) {
            erros = this.tratarRespostaTarefaLoteErro(numeros, mensagem + ' ' + ErrorUtil.getMensagemErro(error));
        }
        return erros;
    }

    concatenarResultado(resultadoLoteAnterior, resultadoLote) {
        return [...resultadoLoteAnterior, ...resultadoLote];
    }

    tratarRespostaTarefaLote(resposta) {
        return resposta
            .filter((elemento) => elemento.tipo === 'ERRO')
            .map((elemento) => {
                return {
                    numeroProcesso: elemento.elemento,
                    erro: true,
                    mensagem: elemento.mensagem
                };
            });
    }

    tratarRespostaTarefaLoteErro(numeros, mensagem) {
        return numeros.map((numero) => ({
            numeroProcesso: numero,
            erro: true,
            mensagem: mensagem
        }));
    }

    async fecharPauta(idSessao, tiposInclusao) {
        const resultado = await this.getSessaoApi().fecharPauta(idSessao, tiposInclusao);
        return resultado;
    }

    async fecharLivroPreferencias(idSessao) {
        const resultado = await this.getSessaoApi().fecharLivroPreferencias(idSessao);
        return resultado;
    }

    async buscarCabecalhoPulicacaoPauta(idSessao) {
        const resultado = await this.getSessaoApi().buscarCabecalhoPulicacaoPauta(idSessao);
        return resultado;
    }

    async buscarCabecalhoEditalCancelamento(idSessao) {
        const resultado = await this.getSessaoApi().buscarCabecalhoEditalCancelamento(idSessao);
        return resultado;
    }

    async existePauta(idSessao) {
        const resultado = await this.getSessaoApi().existePauta(idSessao);
        return resultado;
    }

    async recuperarAutoTexto(siglaOrgaoJudicante) {
        const resultado = await this.getSessaoApi().recuperarAutoTexto(siglaOrgaoJudicante);
        return resultado;
    }

    async cadastrarAutoTexto(data) {
        const resultado = await this.getSessaoApi().cadastrarAutoTexto(data);
        return resultado;
    }

    async editarAutoTexto(data) {
        const resultado = await this.getSessaoApi().editarAutoTexto(data);
        return resultado;
    }

    async removerAutoTexto(data) {
        const resultado = await this.getSessaoApi().removerAutoTexto(data);
        return resultado;
    }

    async recuperarInformacoesRelatorioProcessos(idSessao, listaProcessos) {
        const resultado = await this.getSessaoApi().recuperarInformacoesRelatorioProcessos(idSessao, listaProcessos);
        return resultado;
    }

    async recuperarInformacoesPendenciasConferencia(idSessao, listaProcessos) {
        const resultado = await this.getSessaoApi().recuperarInformacoesPendenciasConferencia(idSessao, listaProcessos);
        return resultado;
    }

    async downloadDocumento(arquivoId) {
        const resultado = await this.getSessaoApi().downloadDocumento(arquivoId);
        return resultado;
    }

    async aprovarSustentacaoOral(arquivoId) {
        const resultado = await this.getSessaoApi().aprovarSustentacaoOral(arquivoId);
        return resultado;
    }

    async reprovarSustentacaoOral(arquivoId, motivoReprovacao) {
        const resultado = await this.getSessaoApi().reprovarSustentacaoOral(arquivoId, motivoReprovacao);
        return resultado;
    }

    async limparMarcacaoSustentacaoOral(arquivoId) {
        const resultado = await this.getSessaoApi().limparMarcacaoSustentacaoOral(arquivoId);
        return resultado;
    }

    async consultarTranscricaoSustentacaoOralEletronica(arquivoId) {
        const resultado = await this.getSessaoApi().consultarTranscricaoSustentacaoOralEletronica(arquivoId);
        return resultado;
    }

    async salvarTranscricaoSustentacaoOralEletronica(arquivoId, textoTranscricao, textoObservacao) {
        const resultado = await this.getSessaoApi().salvarTranscricaoSustentacaoOralEletronica(
            arquivoId,
            textoTranscricao,
            textoObservacao
        );
        return resultado;
    }

    async excluirTranscricaoSustentacaoOralEletronica(arquivoId) {
        const resultado = await this.getSessaoApi().excluirTranscricaoSustentacaoOralEletronica(arquivoId);
        return resultado;
    }

    async consultarPautasDoProcesso(numeroProcesso) {
        const resultado = await this.getSessaoApi().consultarPautasDoProcesso(numeroProcesso);
        return resultado;
    }

    async downloadCertidaoNaoAtendimentoExigencias(sessaoId, numeroProcesso, arquivoId) {
        const resultado = await this.getSessaoApi().downloadCertidaoNaoAtendimentoExigencias(
            sessaoId,
            numeroProcesso,
            arquivoId
        );
        return resultado;
    }

    async gerarCertidaoNaoAtendimentoExigenciasPorProcesso(sessaoId, numeroProcesso, chaveOtp) {
        const resultado = await this.getSessaoApi().gerarCertidaoNaoAtendimentoExigenciasPorProcesso(
            sessaoId,
            numeroProcesso,
            chaveOtp
        );
        return resultado;
    }

    async gerarCertidaoNaoAtendimentoExigencias(sessaoId, numeroProcesso, documentoId, chaveOtp) {
        const resultado = await this.getSessaoApi().gerarCertidaoNaoAtendimentoExigencias(
            sessaoId,
            numeroProcesso,
            documentoId,
            chaveOtp
        );
        return resultado;
    }

    async recuperarMovimentacoesInternas(sessaoId) {
        const resultado = await this.getSessaoApi().recuperarMovimentacoesInternas(sessaoId);
        return resultado;
    }

    async consultarMaterias(sessaoId, numeroProcesso) {
        const resultado = await this.getSessaoApi().consultarMaterias(sessaoId, numeroProcesso);
        return resultado;
    }

    async cadastrarMateria(sessaoId, numeroProcesso, materiaDto) {
        const resultado = await this.getSessaoApi().cadastrarMateria(sessaoId, numeroProcesso, materiaDto);
        return resultado;
    }

    async alterarDescricaoMateria(materiaId, descricao) {
        const resultado = await this.getSessaoApi().alterarDescricaoMateria(materiaId, descricao);
        return resultado;
    }

    async excluirMateria(materiaId) {
        const resultado = await this.getSessaoApi().excluirMateria(materiaId);
        return resultado;
    }

    async cadastrarDeliberacao(materiaId, deliberacaoDto) {
        const resultado = await this.getSessaoApi().cadastrarDeliberacao(materiaId, deliberacaoDto);
        return resultado;
    }

    async alterarDeliberacao(deliberacaoId, deliberacaoDto) {
        const resultado = await this.getSessaoApi().alterarDeliberacao(deliberacaoId, deliberacaoDto);
        return resultado;
    }

    async alterarDescricaoDeliberacao(deliberacaoId, descricao) {
        const resultado = await this.getSessaoApi().alterarDescricaoDeliberacao(deliberacaoId, descricao);
        return resultado;
    }

    async alterarMagistradoResponsavelDeliberacao(deliberacaoId, magistradoResponsavel) {
        const resultado = await this.getSessaoApi().alterarMagistradoResponsavelDeliberacao(
            deliberacaoId,
            magistradoResponsavel
        );
        return resultado;
    }

    async excluirDeliberacao(deliberacaoId) {
        const resultado = await this.getSessaoApi().excluirDeliberacao(deliberacaoId);
        return resultado;
    }

    async incluirVotoDeliberacao(deliberacaoId, magistradoResponsavel, tipoVoto) {
        const resultado = await this.getSessaoApi().incluirVotoDeliberacao(
            deliberacaoId,
            magistradoResponsavel,
            tipoVoto
        );
        return resultado;
    }

    async salvarObservacoes(sessaoId, numeroProcesso, observacaoDto) {
        const resultado = await this.getSessaoApi().salvarObservacoes(sessaoId, numeroProcesso, observacaoDto);
        return resultado;
    }

    gerarResultadoOperacaoIntimacao(intimacoesSucesso, erros) {
        const sucessos = intimacoesSucesso.map((intimacao) => {
            return {
                numeroProcesso: intimacao.numero,
                parte: intimacao.parte,
                erro: false
            };
        });
        const retorno = [...erros, ...sucessos];
        return retorno;
    }

    removerFalhasAtualizarIntimacao(resultados, intimarPautaDto) {
        const intimarPautaDtoAtualizado = { otp: intimarPautaDto.otp, processosIntimacao: [] };

        for (const resultado of resultados) {
            // eslint-disable-next-line unicorn/prefer-continue
            if (!resultado.erro) {
                const elemento = { numero: resultado.numeroProcesso, parte: resultado.parte };
                intimarPautaDtoAtualizado.processosIntimacao.push(elemento);
            }
        }
        return intimarPautaDtoAtualizado;
    }

    async tratarTarefaLoteIntimacao(operacao, intimacoes, mensagem) {
        let erros;

        try {
            const response = await operacao();
            erros = this.tratarRespostaTarefaLoteIntimacao(response.data);
        } catch (error) {
            erros = this.tratarRespostaTarefaLoteIntimacaoErro(
                intimacoes,
                mensagem + ' ' + ErrorUtil.getMensagemErro(error)
            );
        }
        return erros;
    }

    tratarRespostaTarefaLoteIntimacao(resposta) {
        return resposta.map((elemento) => {
            return {
                numeroProcesso: elemento.elemento.numero,
                parte: elemento.elemento.parte,
                erro: elemento.tipo === 'ERRO',
                mensagem: elemento.mensagem
            };
        });
    }

    tratarRespostaTarefaLoteIntimacaoErro(intimacoes, mensagem) {
        return intimacoes.map((intimacao) => ({
            numeroProcesso: intimacao.numero,
            parte: intimacao.parte,
            erro: true,
            mensagem: mensagem
        }));
    }

    async confirmarIntimarPauta(idSessao, intimarPautaDto, enviarCertidao) {
        let intimarPautaDtoSucesso = { ...intimarPautaDto };
        let erros = [];
        let resultados;

        if (enviarCertidao) {
            resultados = await this.gerarCertidaoIntimacao(idSessao, intimarPautaDtoSucesso);
            erros = [...erros, ...this.extrairErros(resultados)];
            intimarPautaDtoSucesso = this.removerFalhasAtualizarIntimacao(resultados, intimarPautaDtoSucesso);
        }
        resultados = await this.intimarPauta(idSessao, intimarPautaDtoSucesso);
        erros = [...erros, ...this.extrairErros(resultados)];
        intimarPautaDtoSucesso = this.removerFalhasAtualizarIntimacao(resultados, intimarPautaDtoSucesso);

        resultados = await this.tramitarIntimacao(idSessao, intimarPautaDtoSucesso);

        return [...erros, ...resultados];
    }

    extrairErros(resultados) {
        return resultados.filter((resultado) => resultado.erro);
    }

    async intimarPauta(idSessao, intimarPautaDto) {
        const resultado = await this.tratarTarefaLoteIntimacao(
            () => this.getSessaoApi().intimarPauta(idSessao, intimarPautaDto),
            intimarPautaDto.processosIntimacao,
            'Intimar partes.'
        );
        return resultado;
    }

    async gerarCertidaoIntimacao(idSessao, intimarPautaDto) {
        const resultado = await this.tratarTarefaLoteIntimacao(
            () => this.getSessaoApi().gerarCertidaoIntimacao(idSessao, intimarPautaDto),
            intimarPautaDto.processosIntimacao,
            'Gerar certidão de inclusão em pauta.'
        );
        return resultado;
    }

    async tramitarIntimacao(idSessao, intimarPautaDto) {
        const resultado = await this.tratarTarefaLoteIntimacao(
            () => this.getSessaoApi().tramitarIntimacao(idSessao, intimarPautaDto),
            intimarPautaDto.processosIntimacao,
            'Gerar movimento de intimação.'
        );
        return resultado;
    }
}
export default SessaoService;
